import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig, ENV_CONFIG } from 'src/app/core/enviroment-config';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { ContainerType } from 'src/app/data/model/container-type';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule
})
export class ContainerTypeApiService extends CrudApiService<ContainerType> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('customer_registry/containertype', http, config);
  }
}
